// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qOHaS","colMin":"styles_colMin__3wfBo"};